class UserLoginModel {
    id: number;
    radAccountId?: number;
    fullName: string;
    userName: string;
    mobile: string;
    token: string;
    isActive: boolean;
    isConfirm: boolean;
    isSMSConfirm: boolean;
    confirmCodeDate?:Date;
    isLegal: boolean;
    constructor(
        id: number,
        radAccountId: number,
        fullName: string,
        userName: string,
        mobile: string,
        token: string,
        isActive: boolean,
        isConfirm: boolean,
        isSMSConfirm: boolean,
        confirmCodeDate: Date,
        isLegal: boolean
    ) {
        this.id = id;
        this.radAccountId = radAccountId;
        this.fullName = fullName;
        this.userName = userName;
        this.mobile = mobile;
        this.token = token;
        this.isActive = isActive;
        this.isConfirm = isConfirm;
        this.isSMSConfirm = isSMSConfirm;
        this.confirmCodeDate = confirmCodeDate;
        this.isLegal = isLegal;
    }

    public static fromJson(json: any): UserLoginModel {
        return new UserLoginModel(
            json["id"],
            json["radAccountId"],
            json["fullName"],
            json["userName"],
            json["mobile"],
            json["token"],
            json["isActive"],
            json["isConfirm"],
            json["isSMSConfirm"],
            json["confirmCodeDate"],
            json["isLegal"]
        );
    }
}

export default UserLoginModel;
